import React from 'react';
import propTypes from 'prop-types';

import MessageModal from 'messages/MessageModal';

const FatalError = ({ error }) => (
  <div className='vra-loading-page__container' data-test-id='sc-fatal-error' >
    <MessageModal
      actions={error.actions}
      bodyText={error.message}
    />
  </div>
);

FatalError.propTypes = {
  error: propTypes.object.isRequired
};

export default FatalError;
